export default {
  data: function() {
    return {
      windowSize: {
        x: 0,
        y: 0
      }
    };
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    }
  },
  computed: {
    height() {
      return (offset = 300) => {
        const tableHeight = this.windowSize.y - offset;
        return `${tableHeight}px`;
      };
    },
    heightAsNumber() {
      return (offset = 300) => {
        return this.windowSize.y - offset;
      };
    }
  }
};
